import React, { useState } from "react";
import styled from "styled-components";
import { Card } from "../../components/containers/styledComponents";
import { NewsTimelineCard } from "../../components/common/NewsTimelineCard/NewsTimelineCard";
import {
  NEWS_LIMIT,
  NEWS_WINDOW_DAYS,
} from "../../components/common/NewsTimelineCard/constants";
import { useCompanyNews } from "../../hooks/useCompanyNews";
import { useNewsPreparation } from "../../hooks/useNewsPreparation";
import { useNewsSearches } from "../../hooks/useNewsSearches";
import { MESSAGES } from "../../messages";

type LatestNewsProps = {
  portfolioIndexIds: string[];
  height: string;
};

const ExpandableCard = styled(Card)`
  flex-shrink: 0;
  transition: width 0.25s ease;
`;

const COLLAPSED_WIDTH = "240px";
const EXPANDED_WIDTH = "460px";

export const LatestNews = ({
  portfolioIndexIds,
  height,
}: LatestNewsProps): JSX.Element => {
  const fundScope = portfolioIndexIds.length > 0 ? portfolioIndexIds : null;
  const { news, isLoading, reload } = useCompanyNews({
    compassCids: null,
    portfolioIndexIds: fundScope,
    days: NEWS_WINDOW_DAYS,
    limit: NEWS_LIMIT,
  });
  const { searches, reload: reloadSearches } = useNewsSearches(null);
  const { prepare, progress } = useNewsPreparation({
    compassCids: null,
    portfolioIndexIds: fundScope,
    onResults: reload,
    onSearched: reloadSearches,
  });
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <ExpandableCard
      h={height}
      wpx={isExpanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH}
      m="0 10px 0 20px"
      isLoading={isLoading}
    >
      <NewsTimelineCard
        news={news}
        isLoading={isLoading}
        compact={!isExpanded}
        expandControl={{
          expanded: isExpanded,
          onToggle: (): void => setIsExpanded((expanded) => !expanded),
        }}
        refreshControl={{
          refreshLabel: MESSAGES.NEWS_FEED.REFRESH,
          generateLabel: MESSAGES.NEWS_FEED.GENERATE,
          onRefresh: prepare,
          progress,
        }}
        searches={searches}
      />
    </ExpandableCard>
  );
};
